// Tarayıcı başına kalıcı cihaz kimliği (clientId). localStorage'da saklanır → aynı IP + aynı kullanıcıyla
// çalışan farklı PC'leri loglarda ayırt etmek için her isteğe X-Client-Id header'ı ile gönderilir.
// NOT: Client-supplied bir değerdir (spoof edilebilir) — güvenlik değil, gözlemlenebilirlik amaçlıdır.

const CLIENT_ID_KEY = 'clientId';

function generateUuid() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    // Fallback (eski tarayıcılar)
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function getClientId() {
    try {
        let id = localStorage.getItem(CLIENT_ID_KEY);
        if (!id) {
            id = generateUuid();
            localStorage.setItem(CLIENT_ID_KEY, id);
        }
        return id;
    } catch {
        // localStorage erişilemezse (private mode vs.) oturumluk bir kimlik üret
        return generateUuid();
    }
}
